// optisel-frontend/src/pages/issues/IssueDateFormat.ts
export function formatPolishDateTime(value: string | number): string {
    return new Date(value).toLocaleString("pl-PL", {timeZone: "Europe/Warsaw"});
}
